import * as React from 'react'
import cx from 'classnames'
import { push as HamburgerMenu } from 'react-burger-menu'
import BurgerIcon from '../Icons/Burger';

import s from './styles.module.css'

export default class BurgerMenu extends React.Component {
  state = { isOpen: false }

  onClick = () => this.setState(state => ({ isOpen: !state.isOpen }))

  render() {
    const { isOpen } = this.state
    const { menuClassName, buttonClassName } = this.props

    return (
      <HamburgerMenu
        pageWrapId="page-wrap"
        outerContainerId="container"
        className={cx(s.menu, menuClassName)}
        isOpen={isOpen}
        customBurgerIcon={<BurgerIcon />}
        burgerButtonClassName={cx(s.button, buttonClassName, {
          [s.open]: isOpen
        })}
        onClick={this.onClick}
        noOverlay
        right
      >
        {this.props.children}
      </HamburgerMenu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BurgerMenu/index.js